export function formatDate(isoString) {
    if (!isoString) return "—";

    const d = new Date(isoString);
    if (isNaN(d)) return "—";

    return new Intl.DateTimeFormat("en-GB", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(d);
  }